import React from 'react';
import styles from './Switch.module.scss';
import ToolTipWrapper from 'app/components/ToolTipWrapper/ToolTipWrapper';

interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  toolTipMessage?: string;
}

const Switch: React.FC<SwitchProps> = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  toolTipMessage = ''
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div className={styles.switchContainer}>
      <div className={styles.switch} onClick={handleClick}>
        <div
          className={`${styles.track} ${checked ? styles.trackChecked : ''} ${
            disabled ? styles.disabled : ''
          }`}
        >
          <div
            className={`${styles.handle} ${
              checked ? styles.handleChecked : ''
            } ${disabled ? styles.disabled : ''}`}
          />
        </div>
      </div>
      {label && (
        <ToolTipWrapper message={toolTipMessage}>
          <div className={styles.textFrame}>
            <span className={styles.text}>{label}</span>
          </div>
        </ToolTipWrapper>
      )}
    </div>
  );
};

export default Switch;
